import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import ProtectedRoute from './components/common/ProtectedRoute';
import AdminLayout from './components/layout/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserForm from './pages/UserForm';
import Businesses from './pages/Businesses';
import BusinessForm from './pages/BusinessForm';
import Staff from './pages/Staff';
import Products from './pages/Products';
import Invoices from './pages/Invoices';
import Mails from './pages/Mails';
import ComposeMail from './pages/ComposeMail';
import SmtpConfigs from './pages/SmtpConfigs';
import SmtpConfigForm from './pages/SmtpConfigForm';
import Plans from './pages/Plans';
import PlanForm from './pages/PlanForm';
import Settings from './pages/Settings';
import AuditLogs from './pages/AuditLogs';
import Broadcast from './pages/Broadcast';

function App() {
  useEffect(() => {
    // Request exact GPS location once on app load
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lon: position.coords.longitude
          };
          localStorage.setItem('adminLocation', JSON.stringify(coords));
        },
        (error) => {
          console.warn('Geolocation permission denied or failed:', error.message);
          localStorage.removeItem('adminLocation');
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {/* Protected Admin Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/users/create" element={<UserForm />} />
            <Route path="/users/edit/:id" element={<UserForm />} />
            <Route path="/businesses" element={<Businesses />} />
            <Route path="/businesses/edit/:id" element={<BusinessForm />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/products" element={<Products />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/mails" element={<Mails />} />
            <Route path="/mails/compose" element={<ComposeMail />} />
            <Route path="/smtp-configs" element={<SmtpConfigs />} />
            <Route path="/smtp-configs/create" element={<SmtpConfigForm />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/plans/create" element={<PlanForm />} />
            <Route path="/plans/edit/:id" element={<PlanForm />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
            <Route path="/broadcast" element={<Broadcast />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
